/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetDataFourthStage200ResponseData } from './GetDataFourthStage200ResponseData'
import {
  GetDataFourthStage200ResponseDataFromJSON,
  GetDataFourthStage200ResponseDataFromJSONTyped,
  GetDataFourthStage200ResponseDataToJSON,
} from './GetDataFourthStage200ResponseData'

/**
 *
 * @export
 * @interface GetDataFourthStage200Response
 */
export interface GetDataFourthStage200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetDataFourthStage200Response
   */
  status: boolean
  /**
   *
   * @type {GetDataFourthStage200ResponseData}
   * @memberof GetDataFourthStage200Response
   */
  data: GetDataFourthStage200ResponseData
}

/**
 * Check if a given object implements the GetDataFourthStage200Response interface.
 */
export function instanceOfGetDataFourthStage200Response(
  value: object
): value is GetDataFourthStage200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetDataFourthStage200ResponseFromJSON(
  json: any
): GetDataFourthStage200Response {
  return GetDataFourthStage200ResponseFromJSONTyped(json, false)
}

export function GetDataFourthStage200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataFourthStage200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetDataFourthStage200ResponseDataFromJSON(json['data']),
  }
}

export function GetDataFourthStage200ResponseToJSON(
  value?: GetDataFourthStage200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetDataFourthStage200ResponseDataToJSON(value['data']),
  }
}
